import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Box,
    HStack,
    Icon,
    Text
} from "@chakra-ui/react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const MapModal = ({ isOpen, onClose }) => {
    const { t } = useLanguage();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={{ base: "full", sm: "lg", md: "2xl" }}
            isCentered
        >
            <ModalOverlay bg="rgba(7, 13, 30, 0.75)" backdropFilter="blur(8px)" />
            <ModalContent
                borderRadius={{ base: "none", sm: "2xl" }}
                overflow="hidden"
                maxW={{ base: "100%", sm: "90%", md: "2xl" }}
                minH={{ base: "100vh", sm: "auto" }}
                bg="#0b132b"
                border="1px solid rgba(223, 186, 115, 0.25)"
                boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.7)"
            >
                <ModalHeader
                    fontSize={{ base: "lg", md: "xl" }}
                    py={4}
                    px={6}
                    color="white"
                    borderBottom="1px solid rgba(255, 255, 255, 0.08)"
                >
                    <HStack spacing={3}>
                        <Box
                            w={8}
                            h={8}
                            borderRadius="lg"
                            bg="rgba(223, 186, 115, 0.15)"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            color="#dfba73"
                        >
                            <Icon as={FaMapMarkerAlt} fontSize="14px" />
                        </Box>
                        <Box>
                            <Text fontWeight="800" fontSize="md">{t("modal.mapTitle")}</Text>
                            <Text fontSize="xs" color="gray.400" fontWeight="normal">{t("connect.addressValue")}</Text>
                        </Box>
                    </HStack>
                </ModalHeader>
                <ModalCloseButton
                    size="md"
                    top={4}
                    right={4}
                    color="gray.400"
                    _hover={{ color: "white", bg: "rgba(255, 255, 255, 0.1)" }}
                    borderRadius="full"
                />
                <ModalBody p={0}>
                    <Box
                        h={{ base: "calc(100vh - 120px)", sm: "450px", md: "520px" }}
                        w="100%"
                    >
                        <iframe
                            title="Legal Titan Office Location"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1523.452863395108!2d44.52235270753406!3d40.21115995018681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aa2ca9bf3ef13%3A0x2c2caaed55457790!2s12%20Nikoghayos%20Tigranyan%20St%2C%20Yerevan%200014!5e0!3m2!1sru!2sam!4v1759492922757!5m2!1sru!2sam"
                            allowFullScreen=""
                            width="100%"
                            style={{ border: 0 }}
                            height="100%"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default MapModal;